import CRUDFormComponent from '../../components/CRUDFormComponent'

const LabExamsForm = () => {
  const fields = [{ key: 'name', label: 'Nombre', type: 'string' }]

  return (
    <>
      <CRUDFormComponent
        entityName={{ singular: 'Examenes de laboratorio' }}
        fields={fields}
        entityUrl="/lab-exams"
      />
    </>
  )
}

export default LabExamsForm
